<div class="claim-widget-container" *ngIf="viewModel">
  <div class="info-container">
    <div class="section">
      <span class="section-header">{{'Screens.Claims.InfoWidget.ClaimNumber' | translate}}</span>
      <hr />
      <div class="description">
        {{viewModel.claimNumber}}
      </div>
    </div>
    <div class="section">
      <span class="section-header">{{'Screens.Claims.InfoWidget.ClaimId' | translate}}</span>
      <hr />
      <div class="description">
        {{viewModel.id}}
      </div>
    </div>
    <div class="section">
      <span class="section-header">{{'Common.SearchColumnsAndDetailsFields.Patient' | translate}}</span>
      <hr />
      <div class="description">
        {{viewModel.patient}}
      </div>
    </div>
    <div class="section">
      <span class="section-header">{{'Common.SearchColumnsAndDetailsFields.Provider' | translate}}</span>
      <hr />
      <div class="description">
        {{viewModel.provider}}
      </div>
    </div>
    <div class="section">
      <span class="section-header">{{'Screens.Claims.InfoWidget.InsurancePlan' | translate}}</span>
      <hr />
      <div class="description">
        {{viewModel.insurancePlanName}}
      </div>
    </div>
    <div class="section">
      <span class="section-header">{{'Common.SearchColumnsAndDetailsFields.SalesOrder' | translate}}</span>
      <hr />
      <div class="description">
        <a href="" [routerLink]="['/sales-orders/details']" [queryParams]="{id: viewModel.saleOrderId}">
          {{viewModel.saleOrderNumber}}
        </a>
      </div>
      <div>
        <span>({{ orderStatusTranslations[viewModel.saleOrderStatus] }})</span>
      </div>
    </div>
    <div class="section amounts">
      <div>
        <p class="amount-header">{{'Screens.Claims.InfoWidget.TotalBilled' | translate}}</p>
        <p class="amount">{{viewModel.billed | wafCurrency}}</p>
      </div>
      <div>
        <p class="amount-header">{{'Screens.Claims.InfoWidget.Paid' | translate}}</p>
        <p class="amount">{{viewModel.paid | wafCurrency}}</p>
      </div>
    </div>
  </div>
</div>
